// Imports
import Vue from "vue";
import Router from "vue-router";
import { trailingSlash } from "@/util/helpers";
import { layout, route } from "@/util/routes";
import axios from "axios";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },

  routes: [
    layout("Default", [
      route("Dashboard"),
      // Pages
      route("UserProfile", null, "components/profile"),
      route("Users", null, "users"),
      // Components
      route("Notifications", null, "components/notifications"),
      route("Icons", null, "components/icons"),
      route("Recieved", null, "recieved"),
      route("Folder", null, "folders"),

      // Tables
      route("Files", null, "folders/:id")
    ]),
    layout("Auth", [
      route("Login", null, "login"),
      route("Register", null, "register")
    ])
  ]
});

router.beforeEach((to, from, next) => {
  return to.path.endsWith("/") ? next() : next(trailingSlash(to.path));
});

export default router;
